// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Auth pages — split layout, warm dark / cream ──────────────────────── */

*, *::before, *::after { box-sizing: border-box; }

/* ── Root split ─────────────────────────────────────────────────────────── */

.auth-root {
  display: flex;
  min-height: 100vh;
  width: 100%;
}

/* ── Brand panel (left, dark) ───────────────────────────────────────────── */

.auth-brand {
  flex: 0 0 42%;
  background: #0f0c0e;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 48px;
  position: relative;
  overflow: hidden;
}

/* Subtle warm glow behind content */
.auth-brand::before {
  content: '';
  position: absolute;
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(200, 130, 74, 0.14) 0%, transparent 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.auth-brand-inner {
  position: relative;
  z-index: 1;
  max-width: 340px;
}

.auth-brand-logomark {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}

.auth-brand-headline {
  margin: 0 0 20px;
  font-size: clamp(32px, 3.5vw, 48px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.8px;
  color: #f0ece6;
}

.auth-brand-accent {
  color: #c8824a;
}

.auth-brand-desc {
  margin: 0 0 48px;
  font-size: 15px;
  font-weight: 400;
  color: #7a7068;
  line-height: 1.75;
}

.auth-brand-dots {
  display: flex;
  gap: 8px;
}

.auth-brand-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c8824a;
  opacity: 0.35;
}

.auth-brand-dots span:first-child { opacity: 1; }
.auth-brand-dots span:nth-child(2) { opacity: 0.6; }

/* ── Form panel (right, cream/white) ────────────────────────────────────── */

.auth-form-panel {
  flex: 1 1;
  background: #faf8f5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 48px;
}

.auth-form-inner {
  width: 100%;
  max-width: 380px;
}

/* Logo — only visible on mobile when brand panel is hidden */
.auth-mobile-logo {
  display: none;
  margin-bottom: 32px;
}

.auth-form-title {
  margin: 0 0 6px;
  font-size: 28px;
  font-weight: 800;
  color: #0f0c0e;
  letter-spacing: -0.5px;
}

.auth-form-sub {
  margin: 0 0 36px;
  font-size: 14px;
  color: #9b8e86;
  font-weight: 400;
}

/* ── Fields ──────────────────────────────────────────────────────────────── */

.auth-field {
  margin-bottom: 20px;
}

.auth-field label {
  display: block;
  margin-bottom: 7px;
  font-size: 13px;
  font-weight: 600;
  color: #3d3530;
  letter-spacing: 0.1px;
}

.auth-field input {
  width: 100%;
  padding: 12px 14px;
  background: #ffffff;
  border: 1.5px solid #e5ddd6;
  border-radius: 10px;
  font-size: 14px;
  color: #0f0c0e;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
  outline: none;
}

.auth-field input::placeholder {
  color: #c4b8af;
}

.auth-field input:focus {
  border-color: #c8824a;
  box-shadow: 0 0 0 3px rgba(200, 130, 74, 0.12);
}

.auth-field input:disabled {
  background: #f5f0eb;
  cursor: not-allowed;
  color: #9b8e86;
}

/* ── Date of birth — three plain selects, year list starts at 18+ ──────── */

.auth-dob-row {
  display: flex;
  gap: 10px;
}

.auth-dob-row select {
  flex: 1 1;
  padding: 12px 10px;
  background: #ffffff;
  border: 1.5px solid #e5ddd6;
  border-radius: 10px;
  font-size: 14px;
  color: #0f0c0e;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.auth-dob-row select:focus {
  border-color: #c8824a;
  box-shadow: 0 0 0 3px rgba(200, 130, 74, 0.12);
}

.auth-dob-row select:disabled {
  background: #f5f0eb;
  cursor: not-allowed;
  color: #9b8e86;
}

/* ── Submit button ───────────────────────────────────────────────────────── */

.auth-submit {
  width: 100%;
  margin-top: 8px;
  padding: 14px;
  background: #0f0c0e;
  color: #f0ece6;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.1px;
  transition: background 0.18s ease, transform 0.12s ease;
}

.auth-submit:hover:not(:disabled) {
  background: #241e28;
  transform: translateY(-1px);
}

.auth-submit:active:not(:disabled) {
  transform: translateY(0);
}

.auth-submit:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Error ───────────────────────────────────────────────────────────────── */

.auth-error {
  padding: 12px 14px;
  background: #fff1f0;
  border: 1.5px solid #fac5c0;
  border-radius: 8px;
  font-size: 13px;
  color: #a02a2a;
  margin-bottom: 20px;
  font-weight: 500;
}

/* ── Switch link ─────────────────────────────────────────────────────────── */

.auth-switch {
  text-align: center;
  margin-top: 24px;
  font-size: 13px;
  color: #9b8e86;
}

.auth-switch a {
  color: #c8824a;
  font-weight: 700;
  text-decoration: none;
}

.auth-switch a:hover {
  text-decoration: underline;
}

/* ── Mobile ──────────────────────────────────────────────────────────────── */

@media (max-width: 768px) {
  .auth-root {
    flex-direction: column;
  }

  .auth-brand {
    display: none;
  }

  .auth-form-panel {
    padding: 48px 24px;
    min-height: 100vh;
    background: #faf8f5;
  }

  .auth-mobile-logo {
    display: block;
  }

  .auth-form-title {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .auth-form-panel {
    padding: 36px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E,yBAAyB,sBAAsB,EAAE;;AAEjD,8EAA8E;;AAE9E;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA,oCAAoC,UAAU,EAAE;AAChD,qCAAqC,YAAY,EAAE;;AAEnD,8EAA8E;;AAE9E;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,0DAA0D;EAC1D,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+EAA+E;;AAE/E;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ── Auth pages — split layout, warm dark / cream ──────────────────────── */\n\n*, *::before, *::after { box-sizing: border-box; }\n\n/* ── Root split ─────────────────────────────────────────────────────────── */\n\n.auth-root {\n  display: flex;\n  min-height: 100vh;\n  width: 100%;\n}\n\n/* ── Brand panel (left, dark) ───────────────────────────────────────────── */\n\n.auth-brand {\n  flex: 0 0 42%;\n  background: #0f0c0e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 48px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Subtle warm glow behind content */\n.auth-brand::before {\n  content: '';\n  position: absolute;\n  width: 420px;\n  height: 420px;\n  background: radial-gradient(circle, rgba(200, 130, 74, 0.14) 0%, transparent 70%);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  pointer-events: none;\n}\n\n.auth-brand-inner {\n  position: relative;\n  z-index: 1;\n  max-width: 340px;\n}\n\n.auth-brand-logomark {\n  display: flex;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.auth-brand-headline {\n  margin: 0 0 20px;\n  font-size: clamp(32px, 3.5vw, 48px);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.8px;\n  color: #f0ece6;\n}\n\n.auth-brand-accent {\n  color: #c8824a;\n}\n\n.auth-brand-desc {\n  margin: 0 0 48px;\n  font-size: 15px;\n  font-weight: 400;\n  color: #7a7068;\n  line-height: 1.75;\n}\n\n.auth-brand-dots {\n  display: flex;\n  gap: 8px;\n}\n\n.auth-brand-dots span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #c8824a;\n  opacity: 0.35;\n}\n\n.auth-brand-dots span:first-child { opacity: 1; }\n.auth-brand-dots span:nth-child(2) { opacity: 0.6; }\n\n/* ── Form panel (right, cream/white) ────────────────────────────────────── */\n\n.auth-form-panel {\n  flex: 1;\n  background: #faf8f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 48px;\n}\n\n.auth-form-inner {\n  width: 100%;\n  max-width: 380px;\n}\n\n/* Logo — only visible on mobile when brand panel is hidden */\n.auth-mobile-logo {\n  display: none;\n  margin-bottom: 32px;\n}\n\n.auth-form-title {\n  margin: 0 0 6px;\n  font-size: 28px;\n  font-weight: 800;\n  color: #0f0c0e;\n  letter-spacing: -0.5px;\n}\n\n.auth-form-sub {\n  margin: 0 0 36px;\n  font-size: 14px;\n  color: #9b8e86;\n  font-weight: 400;\n}\n\n/* ── Fields ──────────────────────────────────────────────────────────────── */\n\n.auth-field {\n  margin-bottom: 20px;\n}\n\n.auth-field label {\n  display: block;\n  margin-bottom: 7px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #3d3530;\n  letter-spacing: 0.1px;\n}\n\n.auth-field input {\n  width: 100%;\n  padding: 12px 14px;\n  background: #ffffff;\n  border: 1.5px solid #e5ddd6;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #0f0c0e;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n  outline: none;\n}\n\n.auth-field input::placeholder {\n  color: #c4b8af;\n}\n\n.auth-field input:focus {\n  border-color: #c8824a;\n  box-shadow: 0 0 0 3px rgba(200, 130, 74, 0.12);\n}\n\n.auth-field input:disabled {\n  background: #f5f0eb;\n  cursor: not-allowed;\n  color: #9b8e86;\n}\n\n/* ── Date of birth — three plain selects, year list starts at 18+ ──────── */\n\n.auth-dob-row {\n  display: flex;\n  gap: 10px;\n}\n\n.auth-dob-row select {\n  flex: 1;\n  padding: 12px 10px;\n  background: #ffffff;\n  border: 1.5px solid #e5ddd6;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #0f0c0e;\n  outline: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.auth-dob-row select:focus {\n  border-color: #c8824a;\n  box-shadow: 0 0 0 3px rgba(200, 130, 74, 0.12);\n}\n\n.auth-dob-row select:disabled {\n  background: #f5f0eb;\n  cursor: not-allowed;\n  color: #9b8e86;\n}\n\n/* ── Submit button ───────────────────────────────────────────────────────── */\n\n.auth-submit {\n  width: 100%;\n  margin-top: 8px;\n  padding: 14px;\n  background: #0f0c0e;\n  color: #f0ece6;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.1px;\n  transition: background 0.18s ease, transform 0.12s ease;\n}\n\n.auth-submit:hover:not(:disabled) {\n  background: #241e28;\n  transform: translateY(-1px);\n}\n\n.auth-submit:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.auth-submit:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ── Error ───────────────────────────────────────────────────────────────── */\n\n.auth-error {\n  padding: 12px 14px;\n  background: #fff1f0;\n  border: 1.5px solid #fac5c0;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #a02a2a;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n/* ── Switch link ─────────────────────────────────────────────────────────── */\n\n.auth-switch {\n  text-align: center;\n  margin-top: 24px;\n  font-size: 13px;\n  color: #9b8e86;\n}\n\n.auth-switch a {\n  color: #c8824a;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.auth-switch a:hover {\n  text-decoration: underline;\n}\n\n/* ── Mobile ──────────────────────────────────────────────────────────────── */\n\n@media (max-width: 768px) {\n  .auth-root {\n    flex-direction: column;\n  }\n\n  .auth-brand {\n    display: none;\n  }\n\n  .auth-form-panel {\n    padding: 48px 24px;\n    min-height: 100vh;\n    background: #faf8f5;\n  }\n\n  .auth-mobile-logo {\n    display: block;\n  }\n\n  .auth-form-title {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .auth-form-panel {\n    padding: 36px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
